import { render, staticRenderFns } from "./ErrorPageLayout.vue?vue&type=template&id=87e9a49c"
import script from "./ErrorPageLayout.vue?vue&type=script&lang=js"
export * from "./ErrorPageLayout.vue?vue&type=script&lang=js"
import style0 from "./ErrorPageLayout.vue?vue&type=style&index=0&id=87e9a49c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports